import { AxiosRequestConfig } from "axios";
import api, { masonCtlKey } from "../api";
import MasonDocument from "lib/mason";
import { ViewDefinition } from "../types";

// API path to the view service
const path = `viewservice`;

/**
 * Get a view definition
 *
 * @param id view id
 */
const getView = (id: string, customOpts?: AxiosRequestConfig["customOpts"]) => {
	return api.request({
		url: `${path}/views/${id}`,
		method: "GET",
		customOpts,
	});
};

/**
 * Get a modified view definition
 * Used to retrieve view definition with any modifications e.g to get the options list from the cdp
 *
 * @param id view id
 */
const getModifiedView = (
	id: string,
	customOpts?: AxiosRequestConfig["customOpts"]
) => {
	return api.request({
		url: `${path}/views/modified/${id}`,
		method: "GET",
		customOpts,
	});
};

/**
 * Get a list of views the user can access
 *
 * @param opts optional axios request params
 */
const getViews = async (
	params?: { offset: number; limit: number; search?: string },
	opts?: AxiosRequestConfig
) => {
	const res = await api.request({
		method: "GET",
		url: `${path}/views`,
		params,
		...opts,
	});

	return {
		hasMore: MasonDocument.hasControl(res.data, masonCtlKey.view.page),
		results: res.data.matches,
		totalCount: res.data.totalCount,
		...(MasonDocument.hasControl(res.data, masonCtlKey.view.page) &&
			MasonDocument.getControlTemplate(res.data, masonCtlKey.view.page)),
	};
};

/**
 * Delete a view definition
 *
 * @param id view id
 */
const deleteViewDefinition = (
	id: string,
	customOpts?: AxiosRequestConfig["customOpts"]
) => {
	return api.request({
		url: `${path}/views/${id}`,
		method: "DELETE",
		customOpts,
	});
};

/**
 * Upload a view definition
 *
 */
const uploadViewDefinition = async (
	value: ViewDefinition
): Promise<boolean> => {
	const req = await api.request({
		url: `${path}/views`,
		method: "POST",
		data: { ...value },
	});

	return Promise.resolve(req.status === 201 ? true : false);
};

export default {
	getView,
	getModifiedView,
	getViews,
	deleteViewDefinition,
	uploadViewDefinition,
};
